import { render } from "./BookingWidget.vue?vue&type=template&id=38d1199a"
import script from "./BookingWidget.vue?vue&type=script&lang=js"
export * from "./BookingWidget.vue?vue&type=script&lang=js"

import "./BookingWidget.vue?vue&type=style&index=0&id=38d1199a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__